import { jsx as _jsx } from "react/jsx-runtime";
import { motion } from 'framer-motion';
const pageVariants = {
    initial: {
        opacity: 0,
    },
    in: {
        opacity: 1,
    },
    out: {
        opacity: 0,
    },
};
const page_transition = {
    type: 'tween',
    ease: 'linear',
    duration: 0.3,
    delay: 0.1,
};
export const MotionDiv = function MotionDiv(props) {
    const { children } = props;
    return (_jsx(motion.div, { initial: "initial", animate: "in", variants: pageVariants, transition: page_transition, children: children }));
};
